import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import { EmpreendimentoForm } from "../../../schemas/Empreendimento_cadastro/empreendimento";
import { UseFormReturn } from "react-hook-form";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";



type Props = {
    open: boolean,
    saving: boolean,
    selectedTipo: number,
    idEmpreendimento: number | null,
    selectedIdCentroCusto: number,
    hookform: UseFormReturn<EmpreendimentoForm>,
    onSubmit: (form: EmpreendimentoForm) => void,
    onClose: () => void,
}

export const CadastroEmpreendimentoModal = ({
    open,
    saving,
    idEmpreendimento,
    selectedTipo,
    selectedIdCentroCusto,
    hookform,
    onSubmit,
    onClose

}: Props) => {

    const [tipoArea, setTipoArea] = useState(Number(selectedTipo) || 1);

    useEffect(() => {
        if (open) {
            setTipoArea(Number(selectedTipo) || 1);
            hookform.setValue('idEmpreendimento', idEmpreendimento ?? 0);
            hookform.setValue('idCentroCusto', selectedIdCentroCusto);
            hookform.setValue('tipo', selectedTipo);
        }
    }, [
        open,
        idEmpreendimento,
        selectedIdCentroCusto,
        selectedTipo,
        hookform,
    ]);

    const handleClose = useCallback(() => {
        if (!saving) {
            onClose();

        }
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: hookform.handleSubmit((form) => onSubmit({ ...form, tipo: tipoArea })),
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>
            <DialogTitle>
                Cadastrar Empreendimento
            </DialogTitle>

            <DialogContent>
                <FormContainer title={"Informações"} arrangement="fullRow">
                    <>
                        <FormControl size="medium" fullWidth>
                            <InputLabel id="tipo-area">Tipo de Área *</InputLabel>
                            <Select
                                labelId="tipo-area"
                                label="Tipo de Área *"
                                required={true}
                                value={tipoArea}
                                onChange={(e) => setTipoArea(Number(e.target.value))}>
                                <MenuItem value={1}>Apartamento</MenuItem>
                                <MenuItem value={2}>Casa</MenuItem>
                                <MenuItem value={3}>Outro</MenuItem>
                            </Select>
                        </FormControl>
                        {
                            tipoArea === 1 && <>

                                <FormMaskedInput
                                    name={'blocosQuantidade'}
                                    label={"Quantidade de Blocos?"}
                                    mask='00'
                                    maskPlaceholder="__"
                                    reactHookForm={hookform}
                                />

                                <FormMaskedInput
                                    name={'andaresQuantidade'}
                                    label={"Quantidade de andares?"}
                                    mask='000'
                                    maskPlaceholder="___"
                                    reactHookForm={hookform}
                                />

                                <FormMaskedInput
                                    name={'apartamentosQuantidade'}
                                    label={"Quantidade de apartamentos por andar?"}
                                    mask='00'
                                    maskPlaceholder="__"
                                    reactHookForm={hookform}
                                />
                            </>
                        }
                        {
                            tipoArea !== 1 && <>

                                <FormMaskedInput
                                    name={'apartamentosQuantidade'}
                                    label={"Quantidade de unidades?"}
                                    mask='0000'
                                    maskPlaceholder="____"
                                    reactHookForm={hookform}
                                />

                            </>
                        }

                    </>
                </FormContainer>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex p-4 gap-4">
                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    )
}